import { Link } from 'react-router-dom';
import { featuredMovies } from '@/mocks/movies';

export default function FeaturedSection() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-1">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500">精选高分热门影视，不容错过</p>
          </div>
          <Link
            to="/category/dianying"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {featuredMovies.map((movie, index) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group animate-scale-in"
              style={{ animationDelay: `${index * 0.08}s` }}
              data-product-shop
            >
              <div className="relative aspect-[2/3] rounded-xl overflow-hidden mb-3 bg-background-200">
                <img
                  src={movie.posterImage}
                  alt={movie.title}
                  title={`${movie.title} - 小辣椒影院高清电影免费在线观看`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
                  <p className="text-white text-xs line-clamp-2">{movie.description}</p>
                </div>
                {/* Rating Badge */}
                <div className="absolute top-2 left-2 bg-primary-500 text-white text-xs font-bold px-2 py-0.5 rounded-md whitespace-nowrap">
                  {movie.rating}
                </div>
                {/* Category Badge */}
                <div className="absolute top-2 right-2 bg-black/60 backdrop-blur-sm text-white text-xs px-2 py-0.5 rounded-md whitespace-nowrap">
                  {movie.tags[0]}
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
                {movie.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-0.5">
                {movie.region} · {movie.year}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}